import { Modifier } from '../modifier';
import type { Damage } from '../damage.type';
import { healthRemove } from '../player.type';
import { ModifierPriority, ModifierTags, StatusEffect } from '../modifier.type';
import { StatusEffectRegistry } from '../status-effects';

export class Stealth extends Modifier {
  static readonly baseTitle = 'Stealth';
  static readonly baseText =
    'When attacked, reduce damage by stacks and fade. On attacking, Convert damage to Pure damage and fade.';
  static readonly baseIcon = 'stealth';
  static readonly baseTags = [ModifierTags.Boon];
  static readonly basePriority = ModifierPriority.Middle;

  // Instance properties that can change
  title = Stealth.baseTitle;
  text = Stealth.baseText;
  icon = Stealth.baseIcon;
  tags: Array<ModifierTags> = [...Stealth.baseTags];
  priority = Stealth.basePriority;

  damageIn(damage: Damage) {
    damage.value -= this.stacks;
    damage.value = Math.max(0, damage.value);
    this.removeStacks(1);
  }

  damageOut(damage: Damage) {
    healthRemove(damage);
    damage.value = 0;
    this.removeStacks(1);
  }
}

// Register the status effect
StatusEffectRegistry.register(StatusEffect.Stealth, Stealth);
